<template>
  <div class="login-form">
    <h2 class="title">管理员登录</h2>
    
    <div class="input-group">
      <label for="username">用户名</label>
      <input v-model="username" type="text" id="username" placeholder="请输入用户名" />
    </div>

    <div class="input-group">
      <label for="password">密码</label>
      <input v-model="password" type="password" id="password" placeholder="请输入密码" />
    </div>

    <button @click="handleLogin" :disabled="isLoading" class="login-btn">
      <span v-if="isLoading" class="loading-spinner">
        <svg class="spinner" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
          </circle>
        </svg>
        登录中...
      </span>
      <span v-else>登录</span>
    </button>
    <p v-if="errorMessage" style="color: red">{{ errorMessage }}</p>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'LoginForm',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false
    };
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.errorMessage = '用户名和密码不能为空';
        return;
      }
    
      // 设置loading状态
      this.isLoading = true;
      this.errorMessage = ''; // 清除之前的错误信息
      
      try {
        const response = await axios.post('/api/login', {
          username: this.username,
          password: this.password
        }, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.data.success) {
          localStorage.setItem('adminLoggedIn', 'true');
          this.$emit('login-success');
        } else {
          this.errorMessage = response.data.message || '用户名或密码错误';
        }
      } catch (error) {
        console.error('登录失败:', error);
        this.errorMessage = error.response?.data?.message || '登录失败，请稍后重试';
      } finally {
        // 无论成功还是失败，都重置loading状态
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-form {
  width: 90%;
  max-width: 400px;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  font-size: 24px;
  color: #172787;
  text-align: center;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 20px;
}

label {
  font-size: 16px;
  color: #172787;
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 12px;
  margin-top: 20px;
  background-color: #172787;
  color: white;
  border: none;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #BDA36C;
}

.login-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinner circle {
  stroke: currentColor;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
